import IndexController from '../index_controller'

export default class extends IndexController {

}
